export function dateNow() {
  return new Date();
}
